import OurServices from '../components/services/OurServices';
import TechBusiness from '../components/services/TechBusiness';
import IdeasSection from '../components/services/IdeasSection';
import { ServicesHeroSection, ScrollReveal } from '../components';

export default function ServicesPage() {
  return (
    <div>
      <ScrollReveal><ServicesHeroSection /></ScrollReveal>
      <ScrollReveal><OurServices /></ScrollReveal>
      <ScrollReveal><TechBusiness /></ScrollReveal>
      <ScrollReveal><IdeasSection /></ScrollReveal>
    </div>
  );
}
